module.exports = __webpack_public_path__ + "media/images/home/boxes/all_devices-00bfaa204df9f3142f01a4ded56e4b82.svg";